function getRuntime() {
  return typeof window !== 'undefined' ? window : null;
}

function buildLaunchUrl(entryUrl) {
  return entryUrl;
}

export function launchLocalPlayer({ sourceUrl, title, entryUrl, storageKey }) {
  const runtime = getRuntime();

  if (!runtime || !sourceUrl || !entryUrl) {
    return {
      launched: false,
      message: entryUrl ? '当前环境无法启动 localplayer' : 'localplayer 入口未配置',
    };
  }

  const storageKeys = Array.from(new Set(['InputMediaURL', storageKey].filter(Boolean)));

  storageKeys.forEach((key) => {
    try {
      runtime.localStorage.setItem(key, sourceUrl);
    } catch (error) {
      runtime.console?.warn?.('[LocalPlayer] failed to write storage key', { key, error });
    }
  });

  try {
    runtime.sessionStorage.setItem('TVOS_AGENT_LOCALPLAYER_TITLE', title || '');
  } catch (error) {
    runtime.console?.warn?.('[LocalPlayer] failed to write session title', { error });
  }

  const launchUrl = buildLaunchUrl(entryUrl);
  runtime.console?.log?.('[LocalPlayer] launching external player', {
    sourceUrl,
    title,
    launchUrl,
    storageKeys,
  });
  runtime.location.href = launchUrl;

  return {
    launched: true,
    launchUrl,
  };
}